const periods = [
  {
    id: "1",
    name: "ANUAL"
  },
  {
    id: "2",
    name: "BIENAL"
  },
  {
    id: "3",
    name: "TRIENAL"
  },
  {
    id: "4",
    name: "BIANUAL"
  },
]

export default periods;
